import React from "react";
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Parts, Types} from "components";
import APPCONFIG from "constants/Config";
import {Alert, Button} from "reactstrap";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import SignatureCanvas from 'react-signature-canvas'
import moment from "moment";
import API from "@beardeddevops/react.api";
import TransactionObject from "components/TransactionObject";
import ReactTable from "react-table";
import converter from "number-to-words";
import UniversalModalOverride from "components/UniversalModalOverride";
import PartsSelect from "../Parts/Selects";
import {confirmAlert} from "react-confirm-alert";
import DispositionQuestions_August2023 from "../Parts/DispositionQuestions_August2023";
import TextField from "@material-ui/core/TextField";


/**
 *  @property {Dispositions_Pendings_Object} state
 *  @property {object} model
 *  @property {Dispositions_Pendings_Properties} model.properties
 *  @property {Dispositions_Pendings_Is} model.is
 *  @property {Dispositions_Pendings_Has} model.has
 */

const signatureCanvasProps = {width: 675, height: 208, className: 'sigCanvas'};

class OnePageObject extends TransactionObject {

	static defaultProps = {
		editing: false,
	}

	constructor(props) {
		super(props,Types.Dispositions_Pendings._name);

		this.state.key = Math.random();

		//Volatile Fields that need presetting
		this.state.us_born = true;
		this.state.us_citizen = true;
		this.state.resigning = false;
		this.state.invalidRaceSubmitted = false;
		this.state.raceButtonsTouched = false;
		this.state.invalidSignature = false;

		this.model.properties.location.required = false;
		this.state.disposition_pending_itemss = [];
		this.state.scrolledToSectionB = false;
		this.state.manual_disposition_items = [];
		this.state.manual_disposition_items_count = 0;

		//for gunsmith dispositions #21A
		this.state.gunsmith = false;

		//For Question 21a required
		this.state.require21a = true;

		this.state.locationKioskAreEqualError = false;
	}

	/** @type Object */
	sigPad14 = null;
	/** @type Object */
	sigPad22 = null;
	clear = (sigPad) => {
		this[sigPad].clear();
	};

	toggleGunsmith = () => {
		this.setState({gunsmith: !this.state.gunsmith});
	}

	checkForNewPending = async () => {
			try {
				let pendings = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.READ);
				pendings.object.pkey = '0';

				await pendings.submit(null, API.RequestType.READ, true).then(() => {
					if (this.props.history.location.pathname !== '/dispositions/one_page/0') {
						this.props.history.push('/dispositions/one_page/0');
					}
				});

				this.handleScrollToSectionB();

			} catch (e) {
				//if someone removes it from kiosk, go back to a blank and start checking again
				if (this.props.history.location.pathname === '/dispositions/one_page/0') {
					this.props.history.push('/dispositions/one_page');
				}
			}
	}

	componentDidMount() {
		super.componentDidMount();
		//if they have this module, auto add a new row
		if(this.props.rootState.hasAutoAcquisitionModule && !this.state.pkey){
			this.handleNewRow();
		}
		if (this.props.kioskMode || this.props.id === '0') {
			//TODO: header/framework stuff "should" handle this, this is what its supposed to do, but rootState for one_page isn't updating?
			document.getElementsByTagName('body')[0].classList.remove('sidebar-open');
			this.checkForNewPending().then();
			//check for a pending every 15 seconds
			this.handleCheckPending = setInterval(async () => {
				await this.checkForNewPending().then();
			}, 15000);

			this.handleScrollToSectionB();
		}

	}


	handle21aRequired = () => {
		this.setState({require21a: !this.state.require21a});
	}

	handleScrollToSectionB = () => {
		//scroll to section B
		if(!this.state.scrolledToSectionB) {
			//TODO: need to account for more firearms and state set
			const element = document.getElementById('sectionB')
			if (element) {
				const topPos = element.getBoundingClientRect().top + window.pageYOffset - 60
				window.scrollTo({
					top: topPos, // scroll so that the element is at the top of the view
					behavior: 'smooth' // smooth scroll
				})
			}
			this.setState({scrolledToSectionB: true});
		}
	}

	componentWillUnmount() {
		//don't check for pendings anymore
		clearInterval(this.handleCheckPending);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;

		if (prevProps.editing !== this.props.editing) {
			if (this.sigPad14 && object.signature_14) {
				this.sigPad14.fromDataURL(object.signature_14);
			}
		}
		this.update = typeof object.pkey !== 'undefined' && object.pkey ? API.RequestType.UPDATE : API.RequestType.CREATE;
	}


	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Dispositions_Pendings_Object} data
	 */
	loadSelfAfter(data) {
		if (this.sigPad14 && data.signature_14) {
			this.sigPad14.fromDataURL(data.signature_14);
		}
		if (this.sigPad22 && data.signature_22) {
			this.sigPad22.fromDataURL(data.signature_22);
		}
		if (APPCONFIG.settings.isDev()) {
			// this.state.actual_transferee = true;
			this.state.actual_intention = false;
			this.state.actual_intention_felony = false;
			this.state.felony_indictment = false;
			this.state.felony_convicted = false;
			this.state.fugitive = false;
			this.state.drug_user = false;
			this.state.mentally_stable = false;
			this.state.dishonorable_discharge = false;
			this.state.restraining_order = false;
			this.state.domestic_violence = false;
			this.state.renounced_citizenship = false;
			this.state.illegal_alien = false;
			this.state.nonimmigrant_visa = false;
			this.setState({key: Math.random()})
		}
		if (typeof data.us_citizen !== 'boolean') {
			this.setState({
				us_citizen: true
			});
		}
		
		this.update = typeof data.pkey !== 'undefined' && data.pkey ? API.RequestType.UPDATE : API.RequestType.CREATE;
	};

	addProducts = async (products) => {
		if (!this.state.pkey) {
			if (typeof this.state.disposition_pending_itemss !== 'undefined') {
				let entries = [...this.state.disposition_pending_itemss, ...products.map(
					/**
					 * @param {Products_Object} product
					 * @returns {{product: *, product_binary_id: *, products: *}}
					 */
					product => {
						return {
							product: product.pkey,
							product_binary_id: product.binary_id,
							products: product
						}
					}
				)];
				let check = new Set();
				entries = entries.filter(obj => !check.has(obj['product_binary_id'] + '-' + obj['product']) && check.add(obj['product_binary_id'] + '-' + obj['product']));
				this.setState({disposition_pending_itemss: entries});
			}
		}
	};

	deleteProduct = (pkey, binary_id) => () => {
		if (typeof this.state.disposition_pending_itemss !== 'undefined') {
			let entries = this.state.disposition_pending_itemss.filter(entry => entry.product !== pkey || entry.product_binary_id !== binary_id);
			this.setState({disposition_pending_itemss: entries});
		}
	}

	handleProcess(event, requestOverride) {

		// noinspection JSValidateTypes
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;

		let result = true;

		if (this.update === 'PUT') {
			if (object.disposition_pending_itemss === null || object.disposition_pending_itemss.length === 0) {
				API.Toast.warn('Product is required.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
				result = false;
			}

		} else {
			result = super.handleProcess(event, requestOverride);
			let superResult = result;
			let scrollTo;

			if(object.require21a && object.actual_transferee !== true && object.actual_transferee !== false) {
				this.setState({'actual_transferee_error': '21.a is required'})
				scrollTo = 'actual_transferee';
				result = false;
			}

			if (!object.weight || object.weight <= 0) {
				this.setState({
					'weight_error': 'Weight is required.'
				});
				scrollTo = 'weight';
				result = false;
			}

			if (!object.height_ft || object.height_ft <= 0) {
				this.setState({
					'height_ft_error': 'Height is required.'
				});
				scrollTo = 'height_ft';
				result = false;
			}

			if (!object.state_of_residence) {
				this.setState({
					'state_of_residence_error': 'State of Residence is required.'
				});
				scrollTo = 'state_of_residence';
				result = false;
			}

			if (!object.us_citizen) {
				if (!object.foreign_citizenship) {
					this.setState({
						'foreign_citizenship_error': 'Foreign Citizenship is required.'
					});
					scrollTo = 'foreign_citizenship';
					result = false;
				}
			}

			//TODO: should probably add the other questions in here so it will scroll to them
			if (object.actual_intention === null) {
				this.setState({
					'actual_intention_error': 'Required.'
				});
				scrollTo = 'actual_intention';
				result = false;
			}

			if (object.actual_intention_felony === null) {
				this.setState({
					'actual_intention_felony_error': 'Required.'
				});
				scrollTo = 'actual_intention_felony';
				result = false;
			}

			if (!object.city_limits) {
				if (!object.city_limits) {
					this.setState({
						'city_limits_error': 'City Limits is required.'
					});
					scrollTo = 'city_limits';
					result = false;
				}
			}

			if (object.us_born) {
				if (!object.birth_city) {
					this.setState({
						'birth_city_error': 'Birth city is required'
					});
					scrollTo = 'birth_city';
					result = false;
				}
				if (!object.birth_state) {
					this.setState({
						'birth_state_error': 'Birth state is required'
					});
					scrollTo = 'birth_state';
					result = false;
				}
			} else {
				if (!object.birth_country) {
					this.setState({
						'birth_country_error': 'Birth country is required'
					});
					scrollTo = 'birth_country';
					result = false;
				}
			}

			if(object.form === 24) {
				if (object.nonimmigrant_visa === null) {
					this.setState({
						'nonimmigrant_visa_error': 'Must be true or false'
					});
					scrollTo = 'nonimmigrant_visa';
					result = false;
				}
			}

			if (object.nonimmigrant_visa === true && typeof object.fall_within_exceptions !== 'boolean') {
				this.setState({
					'fall_within_exceptions_error': 'Must be true or false'
				});
				scrollTo = 'fall_within_exceptions';
				result = false;
			}

			//If every race property value is false, set invalidRaceSubmitted flag
			if(['race_african_american', 'race_american_indian', 'race_asian', 'race_native_hawaiian', 'race_white'].every(r => !this.state[r])) {
				this.setState({invalidRaceSubmitted: true})
				scrollTo = 'race_american_indian';
				result = false;
			}

			if(this.sigPad14.isEmpty()){
				this.setState({invalidSignature: true})
				result = false;
			}

			if (result && this.sigPad14 && this.sigPad14.getCanvas() !== null && !this.sigPad14.isEmpty()) {
				this.state.signature_14 = this.sigPad14.getCanvas().toDataURL('image/png');
				this.state.signature_14_date = moment().local().format('YYYY-MM-DD HH:mm:ss');
			}
			if (result && this.sigPad22 && this.sigPad22.getCanvas() !== null && !this.sigPad22.isEmpty()) {
				this.state.signature_22 = this.sigPad22.getCanvas().toDataURL('image/png');
				this.state.signature_22_date = moment().local().format('YYYY-MM-DD HH:mm:ss');
			}

			if (object.county === 'US' || object.county === 'USA' || object.county === 'U.S.' || object.county === 'U.S.A.' || object.county === 'U S' ||
				object.county === 'U S A' || object.county === 'United States' || object.county === 'United States of America' || object.county === 'America' ||
				object.county === 'US of A' || object.county === 'U S of A' || object.county === 'united states' || object.county === 'usa' || object.county === 'united states of america') {
				this.setState({county_error: 'Invalid County'})
				scrollTo = 'county';
				result = false;
			}

			if (superResult && scrollTo) {
				this.handleScrollTo(scrollTo);
			}

		}
		return result;
	}

	handleScrollTo = (scrollTo) => {
		if(document.getElementsByName(scrollTo)[0].type !== "hidden"){
			document.getElementsByName(scrollTo)[0].scrollIntoView()
		} else {
			document.getElementById(scrollTo).scrollIntoView();
		}
		window.scrollBy(0, -100);
	}

	getSigPad14Ref = (ref) => {
		if (!ref) return;
		this.sigPad14 = ref;
	}

	getSigPad22Ref = (ref) => {
		if (!ref) return;
		this.sigPad22 = ref;
	}

	clearSigPad14Ref = () => {
		confirmAlert({
			title: "Confirm Clear Signature",
			message: "Are you sure you want to clear this signature?",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.clear('sigPad14')
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};
	
	clearSigPad22Ref = () => {
		confirmAlert({
			title: "Confirm Clear Signature",
			message: "Are you sure you want to clear this signature?",
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						this.clear('sigPad22')
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	};

	pendingCancel = (data) => {
		let model = new API.BuildClass(Types.Dispositions_Pendings._name, API.RequestType.UPDATE);
		this.state.signature_35 = data.signature_35;
		this.state.signature_35_date = data.signature_35_date;
		this.state.date = new Date();
		this.update = 'POST_CANCEL';
		model.submit(this, this.update).then(r => this.afterSubmit(r, this.update));
	};

	handleSubmit = async (event, suppressToast = false, suppressProcess = false, pending = false) => {
		if(this.props.rootState.hasAutoAcquisitionModule && !this.state.pkey){
			//TODO: validate errors here
			let error = null;
			this.state.manual_disposition_items.forEach((item) =>{
				if(item.manufacturer === ""){
					item.manufacturer_error = "Required";
					error = 1;
				}
				if(item.model === ""){
					item.model_error = "Required";
					error = 1;
				}
				if(item.serial_number === ""){
					item.serial_number_error = "Required";
					error = 1;
				}
				if(item.type === ""){
					item.type_error = "Required";
					error = 1;
				}
				if(item.caliber === ""){
					item.caliber_error = "Required";
					error = 1;
				}
			});

			//if error, set state and return
			if(error !== null){
				this.setState({manual_disposition_items: this.state.manual_disposition_items});
				return;
			}

			let acqModel = new API.BuildClass(Types.Transactions_Collections._name, 'PUT_AUTO_ACQUISITION');
			acqModel.object.serial_numbers = this.state.manual_disposition_items.map(function(item) { return item["serial_number"]; });
			acqModel.object.models = this.state.manual_disposition_items.map(function(item) { return item["model"]; });
			acqModel.object.types = this.state.manual_disposition_items.map(function(item) { return item["type"]; });
			acqModel.object.manufacturer_others = this.state.manual_disposition_items.map(function(item) { return item["manufacturer"]; });
			acqModel.object.caliber_others = this.state.manual_disposition_items.map(function(item) { return item["caliber"]; });
			acqModel.object.pawn_redemption = this.state.pawn_redemption;
			acqModel.object.private_party_transfer = this.state.private_party_transfer;
			acqModel.object.location = this.state.location;
			acqModel.object.location_binary_id = this.state.location_binary_id;
			acqModel.object.kiosk = this.state.kiosk;
			acqModel.object.kiosk_binary_id = this.state.kiosk_binary_id;

			await acqModel.submit(null, 'PUT_AUTO_ACQUISITION');

			this.props.history.push('/dispositions/pendings')
		} else {
			this.saveTimer = null;

			/** @type {Dispositions_Pendings_Object} */
			let object = this.state;
			let isNew = !object.pkey || object.pkey === '0';

			//This should only happen if you are just reviewing the 4473
			//object.customer_completed && object.signature_14

			if (!this.props.kioskMode && !isNew && !this.props.editing) {
				this.props.history.push('/dispositions/pendings/' + this.props.id);
			} else {
				if (this.props.customer) {
					this.model.parent = this.props.customer;
					this.update = 'PUT_CUSTOMER';
					suppressProcess = true;
				}
				//Section A, Section B
				//Set OG update back here
				super.handleSubmit(event, suppressToast, suppressProcess).then();
			}
		}
	}

	handleToggleShowDLModal = (id) => {
		this.state.currID = id;
		this.setState({showDLmodal: !this.state.showDLmodal});
	}

	handleLettersOnly = (property, value) => {
		const isLetters = (str) => /^[A-Za-z\s]*$/.test(str);
		if (isLetters(value)) {
			this.handleTextFieldPropertyUpdate(property, value);
		}
	};

	// noinspection JSUnusedLocalSymbols
	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.model.parent = null;
		if (this.props.kioskMode) {
			if (!suppressProcess) {
				if (this.sigPad14 && this.sigPad14.getCanvas() !== null) {
					this['sigPad14'].clear();
				}
				if (this.sigPad22 && this.sigPad22.getCanvas() !== null) {
					this['sigPad22'].clear();
				}
				if (window.location.pathname !== '/dispositions/one_page') {
					this.props.history.push('/dispositions/one_page');
					return;
				}
				if (typeof this.props.reloadPage === 'function') {
					this.props.reloadPage();
					window.scrollTo(0, 0);
				}
			}
		} else {
			if (request === 'POST_COMPLETE' || request === 'POST_CANCEL') {
				this.props.history.push('/dispositions/' + data.binary_id + '-' + data.pkey + '#forms');
			} else {
				//First Time
				if (!this.props.editing) {
					this.props.history.push('/dispositions/pendings');
				}
				//Second Plus Time
				else {
					this.props.history.push('/dispositions/pendings/' + this.props.id);
				}
			}
		}
	}

	handleToggleSendToKioskModal = () => {
		this.setState({sendToKioskModalOpen: !this.state.sendToKioskModalOpen});

	}

	handleSendToKioskClick =  () => {
		this.handleToggleSendToKioskModal();
	}


	handleMySelectPropertyUpdate = async (property, value, linked, object) => {
		await this.handleSelectPropertyUpdate(property, value, linked, object);
		if(this.props.locations.length === 1 && this.state.kiosks.location !== this.state.locations.pkey) {
			this.setState({locationKioskAreEqualError: true})
		}
		else {
			this.setState({locationKioskAreEqualError: false})
		}
	}

	handleAfterKiosk = () => {
		// this.setState({id: null, binary_id: null, object: null});
		// this.props.reloadPage();
		this.props.history.push('/dispositions/pendings');
	}

	//for the manual acquisition module
	handleNewRow = () => {
		//manual_disposition_items
		let new_row = {'pkey': this.state.manual_disposition_items_count, 'manufacturer': '',  'manufacturer_error': '', 'model': '', 'model_error': '', 'serial_number': '', 'serial_number_error': '', 'caliber': '', 'caliber_error': '', 'type': '', 'type_error': ''};
		this.state.manual_disposition_items.push(new_row);
		this.setState({manual_disposition_items: this.state.manual_disposition_items, manual_disposition_items_count: this.state.manual_disposition_items_count + 1})
	}

	handleProductUpdate = (index, property = null, value = null) => {
		if(value === null){
			return;
		}
		this.state.manual_disposition_items[index][property] = value;
		//to make errors go away if there are any
		this.state.manual_disposition_items[index][property + '_error'] = '';
		this.setState({manual_disposition_items: this.state.manual_disposition_items});
	}

	handleDeleteManualProduct = () => {
		//delete from the array
		this.state.manual_disposition_items.pop();
		this.setState({manual_disposition_items: this.state.manual_disposition_items, manual_disposition_items_count: this.state.manual_disposition_items_count - 1});
	}

	form = () => {
		/** @type {Dispositions_Pendings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;
		let pdf_url = `${APPCONFIG.settings.apiURL()}/forms/pdfs/atf-f-4473_v5.pdf#page=3`;
		//If a signature does NOT exist then no matter how you slice and dice it this is an "Unfinished" 4473
		//Started from a customer or dummy data. Either way it needs signing to be considered valid
		let disabled = object.signature_14 && this.props.id && this.props.id !== '0';
		let disabledParts = object.signature_14 && (this.props.id || this.props.id === '0');
		if (this.props.editing || this.props.kioskMode) {disabledParts = false;	}
		if (object.signature_14) {
			// console.log(!moment(object.signature_14_date).isSame(moment(), 'day'), this.props.kioskMode, (!object.signature_22 || !moment(object.signature_22_date).isSame(moment(), 'day')));
			if (!moment(object.signature_14_date).isSame(moment(), 'day') && this.props.kioskMode) {
				this.state.resigning = true;
			}
		}
		if (object.signature_22) {
			if (this.props.kioskMode) {
				this.state.resigning = true;
			}
		}

		return (
			<div>
				<div>
					{this.state.locationKioskAreEqualError && <Alert color="warning">
						Warning: This kiosk is not associated with your location.
					</Alert>}
					{!object.pkey && !this.props.kioskMode &&
					<h4 className="section-title mdl-typography--text-center">FFL Boss Pre 4473 Details</h4>}

					{!object.pkey && !this.props.kioskMode && <div className={'row'}>
						<div className={'col-3 mx-auto'}>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Date</span>
									</div>
									<div className={'col-8'}>
										<Framework.Elements.Date
											property={properties.date}
											value={object.date}
											update={this.handleTextFieldPropertyUpdate}
											defaultValue={moment().format('YYYY-MM-DD')}
											appendTime={true}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className={'col-3 mx-auto'}>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={(property, value, linked, object ) => this.handleMySelectPropertyUpdate(property, value, linked, object)}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>
						</div>
						<div className={'col-3 mx-auto'}>
							<div className={'form-group'}>
								<div className="row">
									<div className="col-4">
										<span className="input-label">Kiosk</span>
									</div>
									<div className={'col-8'}>
										<Framework.Elements.Select
											shouldLoad={true}
											update={(property, value, linked, object)=> this.handleMySelectPropertyUpdate(property, value, linked, object)}
											objects={this.props.kiosks}
											property={properties.kiosk}
											value={object.kiosk}
											binary_id={object.kiosk_binary_id}
											error={object.kiosk_error}
											object={object.kiosks}
											text={'name'}
											nullable={false}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>}

					<div>
						<b>WARNING</b>: The information you provide will be used to determine whether you are prohibited by Federal or State law
						from receiving
						a firearm. Certain violations of the Gun Control Act, 18 U.S.C. 921 et. seq., are punishable by up to 15 years
						imprisonment and/or up to a
						$250,000 fine. Any person who exports a firearm without a proper authorization from either the Department of Commerce or
						the
						Department of State, as applicable, is subject to a fine of not more than $1,000,000 and up to 20 years imprisonment.<br/>
						<b>Read the Notices, Instructions, and Definitions on this form.</b> Prepare in original only at the licensed premises
						(including business
						temporarily conducted from a qualifying gun show or event in the same State in which the premises is located) unless the
						transaction
						qualifies under 18 U.S.C. 922(c). <b>All entries must be handwritten in ink unless completed under ATF Rul. 2016-2.</b> PLEASE
						PRINT.
					</div>
					<br/>
					<div style={{textAlign: "center", fontSize: '16px'}}>
						<a href={APPCONFIG.settings.apiURL().toString() + "/forms/pdfs/atf-f-4473_v5.pdf#page=3"} target="_blank">
							<b>View all notices, instructions and definitions</b>
						</a>
					</div>
					<br/>
					<h4 className="section-title mdl-typography--text-center">
						Section A - Must Be Completed By Transferor/Seller Before Transferee/Buyer Completes Section B
						{!object.pkey && !this.props.kioskMode &&
						<div className="pull-right">
							{this.props.rootState.hasAutoAcquisitionModule ?
							<Tooltip
								title="Add row to the table"
								aria-label="Add row to the table">
								<Button onClick={this.handleNewRow} size={"sm"} color="primary">
									<i className={"fa fa-barcode"}/>
									<span className="hidden-xs">&nbsp;&nbsp;Add Firearm</span>
								</Button>
							</Tooltip> :
							<Tooltip
								title="Products you have previously acquired and disposed / transferred can be found here."
								aria-label="Products you have previously acquired and disposed / transferred can be found here.">
								<Button onClick={this.handleToggleModalLookup} size={"sm"} color="primary">
									<i className={"fa fa-barcode"}/>
									<span className="hidden-xs">&nbsp;&nbsp;Add Items</span>
								</Button>
							</Tooltip>
							}

							<UniversalModalOverride
								locations={this.props.locations}
								states={this.props.states}
								history={this.props.history}
								name={"In Stock Products"}
								object={Collections.ProductsExisting}
								toggle={this.state.modalLookup}
								reportClose={this.handleReportProductClose}
								afterSave={this.addProducts}
								size={"xl"}
								status={"GET_IN_STOCK"}
								objectProps={{
									requestedLocation: object.location_binary_id + '-' + object.location
								}}
							/>
						</div>}
					</h4>
					{object.pkey && this.props.kioskMode &&
						<h3 className="section-title mdl-typography--text-center" style={{color: "darkred", fontWeight: 900}}>
							Section A cannot be edited while in kiosk mode
						</h3>
					}




					{this.props.rootState.hasAutoAcquisitionModule  && !this.state.pkey ?
						<div>
							{this.state.manual_disposition_items?.map((product, i, row) => {
								return (
									<div className={"row"} key={product.pkey}>
										{/*if the last one, show delete button*/}
										{i+1 === row.length && row.length !== 1 &&
											<div className="form-group col-sm-auto" style={{marginLeft: 10, marginRight: -10}}>
												<Button className="rounded-circle" color="danger" size={"sm"} block={true} onClick={this.handleDeleteManualProduct}>
													<i className={"fa fa-minus"}/>
												</Button>
											</div>
										}
										<div className="form-group col mx-1">
											<Framework.Elements.TextField
												label={"Manufacturer and Importer"}
												value={product.manufacturer}
												error={product.manufacturer_error}
												property={{...properties.manufacturer, ignore_validation: true}}
												update={(property, value) => {
													this.handleProductUpdate(product.pkey, 'manufacturer', value)
												}}
											/>
										</div>

										<div className="form-group col mx-1">
											<Framework.Elements.TextField
												label={"Model"}
												value={product.model}
												error={product.model_error}
												property={{...properties.model, ignore_validation: true}}
												update={(property, value) => {
													this.handleProductUpdate(product.pkey, 'model', value)
												}}
											/>
										</div>

										<div className={"form-group col mx-1"}>
											<Framework.Elements.TextField
												label={"Serial Number"}
												value={product.serial_number}
												error={product.serial_number_error}
												property={{...properties.serial_number, ignore_validation: true}}
												update={(property, value) => {
													this.handleProductUpdate(product.pkey, 'serial_number', value)
												}}
											/>
										</div>

										<div className="form-group col mx-1">
											<Framework.Elements.Select
												label={"Type"}
												shouldLoad={true}
												update={(property, value) => {
													this.handleProductUpdate(product.pkey, 'type', value)
												}}
												property={{...properties.type, class: false, name: 'Type'}}
												value={product.type}
												error={product.type_error}
												model={Types.Products_Types._name}
												id={'name'}
												nullable={true}
												limit={null}
											/>
										</div>

										<div className="form-group col mx-1">
											<Framework.Elements.TextField
												label={"Caliber"}
												value={product.caliber}
												error={product.caliber_error}
												property={{...properties.caliber, ignore_validation: true}}
												update={(property, value) => {
													this.handleProductUpdate(product.pkey, 'caliber', value)
												}}
											/>
										</div>
									</div>
								)})}
						</div>:
					<div className={'form-group'}>

						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "Manufacturer",
									id: 'manufacturer',
									/** @param {Products_Object} obj */
									accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
								},
								{
									Header: "Model",
									accessor: "model",
								},
								{
									Header: "Serial",
									accessor: "serial_number",
								},
								{
									Header: "Type",
									accessor: "type",
								},
								{
									Header: "Caliber",
									id: 'caliber',
									/** @param {Products_Object} obj */
									accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
								},
								...!object.pkey ? [
									{
										Header: "",
										className: "button-cell",
										filterable: false,
										sortable: false,
										width: 40,
										Cell: props => <Button
											color="primary"
											size="sm"
											onClick={this.deleteProduct(props.original.pkey, props.original.binary_id)}
											block={true}>
											<i className="fa fa-times"/>
										</Button>
									},
								] : []
							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={object.disposition_pending_itemss.map(entry => entry.products)}
							pages={1} // Display the total number of pages
							// loading={loading} // Display the loading overlay when we need it
							onSortedChange={this.onSortedChange}
							//page={this.state.page}
							//onPageChange={this.onPageChange}
							loadingText="Requesting Data"
							expanderDefaults={{
								sortable: false,
								resizable: false,
								filterable: false,
								width: undefined
							}}
							showPagination={false}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSize={object.disposition_pending_itemss.length}
							className="-striped -highlight"
						/>

					</div>
				}

					<hr/>

					<div className={"row"}>
						<div className="form-group col-4">
							<p style={{minHeight: 48}}>
								6. Total Number of Firearms to be Transferred (Please spell total number e.g., one, two, etc. Do not use
								numerals.)
							</p>
							<Framework.Elements.TextField
								label={'Total Number of Firearms'}
								value={this.props.rootState.hasAutoAcquisitionModule && !this.state.pkey ? converter.toWords(object.manual_disposition_items.length) : converter.toWords(object.disposition_pending_itemss.length)}
								error={""}
								disabled
								update={() => {
								}}
							/>
						</div>
						<div className="form-group col-4">
							<p style={{minHeight: 48}}>
								7. Check if any part of this transaction is a pawn redemption.<br/>
								Record Line Number(s) From Question 1:
							</p>
							<div className={'row'}>
								<div className={'col-6'}>
									<span className="input-label">Pawn Redemption</span>
								</div>
								{/*Twin City Pawn stuff with uncheck and nullable*/}
								<div className={'col-6 text-right'}>
									<Framework.Elements.ButtonSwitch
										property={properties.pawn_redemption}
										value={object.pawn_redemption}
										error={object.pawn_redemption_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
										{...(this.props.rootState.hasTwinCityPawnModule && { uncheck: true })}
										{...(this.props.rootState.hasTwinCityPawnModule && { nullable: true })}
										disabled={!!this.state.pkey}
									/>
								</div>
							</div>
						</div>
						<div className="form-group col-4">
							<p style={{minHeight: 48}}>
								8. Check if this transaction is to facilitate a private party transfer.<br/>
							</p>
							<div className={'row'}>
								<div className={'col-6'}>
									<span className="input-label">Private Party Transfer</span>
								</div>
								<div className={'col-6 text-right'}>
									<Framework.Elements.ButtonSwitch
										property={properties.private_party_transfer}
										value={object.private_party_transfer}
										error={object.private_party_transfer_error}
										update={this.handleTextFieldPropertyUpdate}
										labelTrue={'Yes'}
										labelFalse={'No'}
										disabled={!!this.state.pkey}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				{!object.pkey && this.props.kioskMode && <div>
					<br/>
					<p style={{textAlign: "center"}}><b>Waiting for Section A</b></p>
				</div>}

				{object.pkey && <div>
					<br/>
					<br/>

					<fieldset disabled={!!disabledParts}>
						<h4 className="section-title mdl-typography--text-center" id={"sectionB"}>
							Section B - Must Be Completed Personally By Transferee/Buyer
						</h4>

						<h4 className="section-title mdl-typography--text-center">
							Transferee's Full Name
						</h4>
						<div className={"row"}>
							<div className="form-group col-3">
								<h4 className="section-title mdl-typography--text-center">
									Last Name
								</h4>
								<Framework.Elements.TextField
									label={"Last Name"}
									property={properties.name_last}
									value={object.name_last}
									error={object.name_last_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group col-3">
								<h4 className="section-title mdl-typography--text-center">
									First Name
								</h4>
								<Framework.Elements.TextField
									label={"First Name"}
									property={properties.name_first}
									value={object.name_first}
									error={object.name_first_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group col-3">
								<h4 className="section-title mdl-typography--text-center">
									Middle Name
								</h4>
								<Framework.Elements.TextField
									label={"Middle Name"}
									property={properties.name_middle}
									value={object.name_middle}
									error={object.name_middle_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
								<span style={{fontSize: '13px'}}>*<i>If no middle name, record NMN</i></span><br/>
								<span style={{fontSize: '13px'}}>*<i>Must spell out entire middle name</i></span>
							</div>
							<div className="form-group col-3">
								<h4 className="section-title mdl-typography--text-center">
									Suffix
								</h4>
								<PartsSelect.CustomerSuffix
									properties={properties}
									object={object}
									update={this.handleSelectPropertyUpdate}
									disabledParts={!!disabledParts}
									helperText={"If no middle name, record NMN"}
								/>
								<span style={{fontSize: '13px'}}>*<i>Not Mr/Ms/Mrs/Dr</i></span>
							</div>
						</div>


						<h4 className="section-title mdl-typography--text-center">
							Residence Address &nbsp;
							<span style={{fontSize: '10px'}}>
								 (Cannot be a post office box)
							</span>
						</h4>
						<div className={'row'}>
							<div className={'form-group col-3'}>
								<Framework.Elements.TextField
									property={properties.street_1}
									value={object.street_1}
									error={object.street_1_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={'form-group col-3'}>
								<Framework.Elements.TextField
									property={properties.street_2}
									value={object.street_2}
									error={object.street_2_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={'form-group col-3'}>
								<Framework.Elements.TextField
									property={properties.city}
									value={object.city}
									error={object.city_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

							<div className="form-group col-3">
								<Framework.Elements.Select
									label={"Reside in City Limits?"}
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: 'Y', name: 'Yes'},
										{pkey: 'N', name: 'No'},
										{pkey: 'U', name: 'Unknown'},
									]}
									property={properties.city_limits}
									value={object.city_limits}
									error={object.city_limits_error}
									text={'name'}
									nullable={true}
									limit={null}
									disabled={!!disabledParts}
								/>
							</div>
							<div className={'form-group col-3'}>
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									property={properties.state}
									value={object.state}
									error={object.state_error}
									id={'short'}
									model={Types.States._name}
									nullable={true}
									limit={null}
									disabled={!!disabledParts}
								/>
							</div>
							<div className={'form-group col-3'}>
								<Framework.Elements.ZipCode
									property={properties.zip}
									value={object.zip}
									error={object.zip_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className={'form-group col-3'}>
								<Framework.Elements.TextField
									property={properties.county}
									value={object.county}
									error={object.county_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						<h4 className="section-title mdl-typography--text-center">
							Place of Birth, Height, Weight, Gender and Birth Date
						</h4>
						<div className={'row'}>
							<div className="form-group col-2">
								<Framework.Elements.ButtonSwitch
									property={properties.us_born}
									value={object.us_born}
									error={object.us_born_error}
									update={this.handleTextFieldPropertyUpdate}
									labelTrue={'U.S.'}
									labelFalse={'Foreign'}
								/>
							</div>
							<div className={"form-group col-3"}>
								{this.state.us_born === true ?

									<div className={"row"}>
										<div className={"col-md-6"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.birth_city}
													value={object.birth_city}
													error={object.birth_city_error}
													update={this.handleLettersOnly}
												/>
											</div>
										</div>
										<div className={"col-md-6"}>
											<div className="form-group">
												<Framework.Elements.Select
													shouldLoad={this.state.loaded}
													update={this.handleSelectPropertyUpdate}
													property={properties.birth_state}
													value={object.birth_state}
													error={object.birth_state_error}
													id={'short'}
													model={Types.States._name}
													nullable={true}
													limit={null}
													disabled={!!disabledParts}
												/>
											</div>
										</div>
									</div> :

									<div className="form-group">
										<Framework.Elements.TextField
											property={properties.birth_country}
											value={object.birth_country}
											error={object.birth_country_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								}
							</div>
							<div className="form-group col-1">
								<Framework.Elements.TextField
									property={properties.height_ft}
									value={object.height_ft}
									error={object.height_ft_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group col-1">
								<Framework.Elements.TextField
									property={properties.height_in}
									value={object.height_in}
									error={object.height_in_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group col-1">
								<Framework.Elements.TextField
									property={properties.weight}
									value={object.weight}
									error={object.weight_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group col-2">
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									update={this.handleSelectPropertyUpdate}
									objects={[
										{pkey: 'M', name: 'Male'},
										{pkey: 'F', name: 'Female'},
										{pkey: 'O', name: 'Non-Binary'},
									]}
									property={properties.gender}
									value={object.gender}
									error={object.gender_error}
									text={'name'}
									nullable={true}
									limit={null}
									disabled={!!disabledParts}
								/>
							</div>
							<div className="form-group col-2">
								<Framework.Elements.Date
									property={properties.birth_date}
									value={object.birth_date}
									error={object.birth_date_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>

						<div className={"row"}>
							<div className={'form-group col-3'}>
								<h4 className="section-title">
									Ethnicity
									<span className="OnePage headerFinePrint">
										Select One
									</span>
								</h4>
								<div className={'form-group'}>
									<div className={'row'}>
										<div className={'col-6'}>
											<span className="input-label">Hispanic / Latino</span>
										</div>
										<div className={'col-6 text-right'}>
											<Framework.Elements.ButtonSwitch
												property={properties.ethnicity_hispanic}
												value={object.ethnicity_hispanic}
												error={object.ethnicity_hispanic_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className={'form-group col-9'}>
								<h4 className="section-title">
									Race
									<span className="OnePage headerFinePrint">
										Select One or More
									</span>
								</h4>
								{this.state.invalidRaceSubmitted &&
									<div className={'row'}>
										<div className={'col errorColor pl-3'} style={{marginTop: '-10px', marginBottom: '10px'}}>
											<em>Required - please answer "Yes" to at least one of the following</em>
										</div>
									</div>
								}
								<div className={'row'}>
									<div className={'form-group col-4 dispo-race-question-col'}>
										<div className={'row'}>
											<div className={'col-6 text-right'}>
												<span className="input-label">AM Indian or AK Native</span>
											</div>
											<div className={'col-6'}>
												<Framework.Elements.ButtonSwitch
													property={properties.race_american_indian}
													value={object.race_american_indian}
													error={object.race_american_indian_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
									<div className={'form-group col-4 dispo-race-question-col'}>
										<div className={'row'}>
											<div className={'col-6 text-right'}>
												<span className="input-label">Black or African American</span>
											</div>
											<div className={'col-6'}>
												<Framework.Elements.ButtonSwitch
													property={properties.race_african_american}
													value={object.race_african_american}
													error={object.race_african_american_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
									<div className={'form-group col-3 dispo-race-question-col'}>
										<div className={'row'}>
											<div className={'col-6 text-right'}>
												<span className="input-label">White</span>
											</div>
											<div className={'col-6'}>
												<Framework.Elements.ButtonSwitch
													property={properties.race_white}
													value={object.race_white}
													error={object.race_white_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
									<div className={'form-group col-4 dispo-race-question-col'}>
										<div className={'row'}>
											<div className={'col-6 text-right'}>
												<span className="input-label">Asian</span>
											</div>
											<div className={'col-6'}>
												<Framework.Elements.ButtonSwitch
													property={properties.race_asian}
													value={object.race_asian}
													error={object.race_asian_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
									<div className={'form-group col-4 dispo-race-question-col'}>
										<div className={'row'}>
											<div className={'col-6 text-right'}>
												<span className="input-label">Native HAW / Pacific Isl.</span>
											</div>
											<div className={'col-6'}>
												<Framework.Elements.ButtonSwitch
													property={properties.race_native_hawaiian}
													value={object.race_native_hawaiian}
													error={object.race_native_hawaiian_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div>
								</div>

							</div>

						</div>


						<div className={"row"}>
							<div className={"col-md-6"}>
								<h4 className="section-title">State of Residency, Citizenship</h4>
								<div className={"row"}>
									<div className={"col-md-6"}>
										<div className="form-group">
											<Framework.Elements.Select
												shouldLoad={this.state.loaded}
												update={this.handleSelectPropertyUpdate}
												property={properties.state_of_residence}
												value={object.state_of_residence}
												error={object.state_of_residence_error}
												id={'short'}
												model={Types.States._name}
												nullable={true}
												limit={null}
												disabled={!!disabledParts}
											/>
										</div>
									</div>
									<div className="col-md-6 mdl-typography--text-right">
										<div className="form-group">
											<Framework.Elements.ButtonSwitch
												property={properties.us_citizen}
												value={object.us_citizen}
												error={object.us_citizen_error}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={'U.S.'}
												labelFalse={'Other'}
											/>
										</div>
									</div>
								</div>

								{object.us_citizen === false ?
									<div className={"row"}>
										<div className={"col-md-6"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.foreign_citizenship}
													value={object.foreign_citizenship}
													error={object.foreign_citizenship_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
										<div className={"col-md-6"}>
											<div className="form-group">
												<Framework.Elements.TextField
													property={properties.alien_number}
													value={object.alien_number}
													error={object.alien_number_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
										</div>
									</div> : null}
							</div>


							<div className={"col-md-6"}>
								{this.props.rootState.hasMichiganRIModule && <section id={"ri-060"}>
									<h4 className="section-title">Michigan RI-060 Information</h4>
									<div>
										<div className={"row"}>
											<div className="col-6">
												<Framework.Elements.TextField
													label={'Mcoles # (If Applicable)'}
													property={properties.mcoles_number}
													value={object.mcoles_number}
													error={object.mcoles_number_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
											<div className="col-6">
												<Framework.Elements.TextField
													label={'CPL # (If Applicable)'}
													property={properties.cpl_number}
													value={object.cpl_number}
													error={object.cpl_number_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>

										</div>
									</div> </section>}

							</div>
							</div>


					</fieldset>

					<fieldset disabled={!!disabled}>
						{this.state.form === 21 ?
							<Parts.DispositionQuestions
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								handle21aRequired={this.handle21aRequired}
							/>
							:
							<Parts.DispositionQuestions_August2023
								gunsmithDispo={this.toggleGunsmith}
								object={object}
								properties={properties}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								handle21aRequired={this.handle21aRequired}

							/>
						}
					</fieldset>

					<fieldset disabled={!!disabledParts}>
						<h4 className="section-title mdl-typography--text-center">
							Optional Information
						</h4>
						<div className={"row"}>
							<div className={"col-3"}>
								<h4 className="section-title">Social Security Number</h4>
								<div className={'form-group'}>
									<Framework.Elements.TextField
										label={"SSN"}
										property={properties.ssn}
										value={object.ssn}
										error={object.ssn_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className={"col-3"}>
								<h4 className="section-title">Phone Number</h4>
								<div className={'form-group'}>
									<Framework.Elements.PhoneNumber
										property={properties.number}
										value={object.number}
										error={object.number_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className={"col-3"}>
								<h4 className="section-title">Email Address</h4>
								<div className={'form-group'}>
									<Framework.Elements.EmailAddress
										property={properties.email}
										value={object.email}
										error={object.email_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<div className={"col-3"}>
								<h4 className="section-title">UPIN</h4>
								<div className={'form-group'}>
									<Framework.Elements.TextField
										property={properties.upin}
										value={object.upin}
										error={object.upin_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>
					</fieldset>
					<h4 className="section-title mdl-typography--text-center">
						Section A - Firearm Information Recap
					</h4>
					<div className={'form-group'}>

						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "Manufacturer",
									id: 'manufacturer',
									/** @param {Products_Object} obj */
									accessor: obj => (obj.manufacturer ? obj.manufacturers.name : obj.manufacturer_other)
								},
								{
									Header: "Model",
									accessor: "model",
								},
								{
									Header: "Serial",
									accessor: "serial_number",
								},
								{
									Header: "Type",
									accessor: "type",
								},
								{
									Header: "Caliber",
									id: 'caliber',
									/** @param {Products_Object} obj */
									accessor: obj => (obj.caliber ? obj.calibers.name : obj.caliber_other)
								},
								...!object.pkey ? [
									{
										Header: "",
										className: "button-cell",
										filterable: false,
										sortable: false,
										width: 40,
										Cell: props => <Button
											color="primary"
											size="sm"
											onClick={this.deleteProduct(props.original.pkey, props.original.binary_id)}
											block={true}>
											<i className="fa fa-times"/>
										</Button>
									},
								] : []
							]}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={object.disposition_pending_itemss.map(entry => entry.products)}
							pages={1} // Display the total number of pages
							// loading={loading} // Display the loading overlay when we need it
							onSortedChange={this.onSortedChange}
							//page={this.state.page}
							//onPageChange={this.onPageChange}
							loadingText="Requesting Data"
							expanderDefaults={{
								sortable: false,
								resizable: false,
								filterable: false,
								width: undefined
							}}
							showPagination={false}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							pageSize={object.disposition_pending_itemss.length}
							className="-striped -highlight"
						/>

					</div>
					{!this.state.resigning && <div>
						<p className="mdl-typography--text-center">
							<b>
								I certify that my answers in Section B are true, correct, and complete. I have read and understand the
								Notices,
								Instructions, and Definitions on ATF Form
								4473. I understand that answering “yes” to question 21.a. if I am not the actual transferee/buyer is a
								crime
								punishable as a felony under Federal law,
								and may also violate State and/or local law. I understand that a person who answers “yes” to any of the
								questions
								21.b. through 21.l. as well as 21.n. is prohibited from
								receiving, possessing, or purchasing a firearm. I understand that a person who answers “yes” to question 21.m.1. is
								prohibited
								from receiving or possessing a firearm,
								unless the person answers “yes” to question 21.m.2. and provides the documentation required in 26.d. I
								also
								understand that making any false oral or
								written statement, or exhibiting any false or misrepresented identification with respect to this
								transaction, is a
								crime punishable as a felony under Federal
								law, and may also violate State and/or local law. I further understand that the repetitive purchase of
								firearms
								for the purpose of resale to predominantly earn a profit without a Federal firearms license is a violation of Federal
								law.
							</b>
						</p>
						<div className={'row'} style={{justifyContent: "center"}}>
								<div className="mdl-typography--text-center">
									<Card style={{display: 'flex', flexDirection: 'column'}}>
										{this.state.invalidSignature &&
											<div className={'row'}>
												<div className={'col errorColor pl-3'} style={{marginTop: '-10px', marginBottom: '10px'}}>
													<em>Signature is required</em>
												</div>
											</div>
										}
										<CardContent className="OnePage positionRelative">
											<span className={'signature'}/>
											<div style={{backgroundColor: '#f2f3f4'}}>
											{disabled ?
												<img src={object.signature_14} alt={'Signature for Line 20'}/> :
												<SignatureCanvas penColor='black' canvasProps={signatureCanvasProps} minWidth={3}
												                 ref={this.getSigPad14Ref}/>}
												</div>
										</CardContent>
										{!disabled && <CardActions className="OnePage signatureClearButtonContainer">
											<Button color="secondary" onClick={this.clearSigPad14Ref}>Clear Signature</Button>
										</CardActions>}
									</Card>
								</div>
						</div>
					</div>}
					{(this.state.resigning || object.signature_22) && <div>
						<p className="mdl-typography--text-center">
							<b>I certify that all of my responses in Section B of this form are still true, correct, and complete.</b>
						</p>
						<div className={'row'} style={{justifyContent: "center"}}>
								<div className="mdl-typography--text-center">
									<Card>
										<CardContent className="OnePage positionRelative">
											<span className={'signature'}/>
											<div style={{backgroundColor: '#f2f3f4'}}>
											{disabled && !this.state.resigning ?
												<img src={object.signature_22} alt={'Signature for Line 30'}/> :
												<SignatureCanvas penColor='black' canvasProps={signatureCanvasProps} minWidth={3}
												                 ref={this.getSigPad22Ref}/>}
											</div>

										</CardContent>
										{!disabled && <CardActions className="OnePage signatureClearButtonContainer">
											<Button color="secondary" onClick={this.clearSigPad22Ref}>Clear Signature</Button>
										</CardActions>}
									</Card>
								</div>
						</div>
					</div>}

					<div style={{textAlign: "center", fontSize: '16px'}}>
						<a href={pdf_url} target="_blank">
							<b>View all notices, instructions and definitions</b>
						</a>
					</div>
				</div>}


			</div>
		)
	}

	render() {
		let {loading} = this.state;

		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}

		let isNew = !this.state.pkey || this.state.pkey === '0';
		return (
			<div>
				<Card>
					<CardContent className="OnePage formContainer">
						{this.form()}
						<hr className="OnePage formHR"/>
						{this.state.actual_transferee !== true && this.state.actual_transferee !== false && this.state._id !== '' && <Alert color="danger">
								WARNING: QUESTION 21.a HAS NOT BEEN FILLED OUT. MAKE SURE THE FOLLOWING EXCEPTION APPLIES: <br></br>
								Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer 21.a. and may proceed to question 21.b.
							</Alert>}

					</CardContent>
					{(!this.props.kioskMode || !isNew) &&
						<CardActions style={{justifyContent: 'space-between'}}>
							{/*{(isNew || this.props.editing || this.state.resigning || !this.state.signature_14) &&*/}
							{/*<Button color="secondary" onClick={this.handleClearForm}>Clear Form</Button>}*/}

							{!isNew && !this.props.kioskMode &&
								<Button color="danger" onClick={this.pendingCancel}>
									Record & Cancel 4473
								</Button>
							}

							{!isNew && !this.props.kioskMode &&
								<Button onClick={this.handleSendToKioskClick} color="warning" style={{marginLeft: 'auto'}}>
									Send To Kiosk
								</Button>
							}

							{/*{isNew &&*/}
							{/*	<Framework.Elements.ButtonSwitch*/}
							{/*	property={this.model.properties.dl_scan_toggle}*/}
							{/*	value={this.state.dl_scan_toggle}*/}
							{/*	error={this.state.dl_scan_toggle_error}*/}
							{/*	update={this.handleTextFieldPropertyUpdate}*/}
							{/*/>}*/}

							<Button color="primary" onClick={this.handleSubmit} style={{marginLeft: 'auto'}}>
								{isNew ? 'Send to Kiosk' : (this.props.kioskMode || this.props.editing || this.state.resigning || !this.state.signature_14 ? 'Save & Continue' : 'Continue 4473')}
							</Button>
						</CardActions>
					}

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</Card>

				<UniversalModalOverride
					locations={this.props.locations}
					kiosks={this.props.kiosks}
					states={this.props.states}
					history={this.props.history}
					id={this.props.id}
					name={"Send to Kiosk"}
					object={Objects.SendToKiosk}
					showModal={this.state.sendToKioskModalOpen}
					handleToggle={this.handleToggleSendToKioskModal}
					afterSave={this.handleAfterKiosk}
					hideGoTo={true}
				/>
			</div>
		)
	}
}

export default Framework.Components.withRootState(OnePageObject);

